import { render, staticRenderFns } from "./banksetPopupCLABE.vue?vue&type=template&id=df889634&scoped=true"
import script from "./banksetPopupCLABE.vue?vue&type=script&lang=js"
export * from "./banksetPopupCLABE.vue?vue&type=script&lang=js"
import style0 from "./banksetPopupCLABE.vue?vue&type=style&index=0&id=df889634&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df889634",
  null
  
)

export default component.exports